/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Daterangepicker_Invalidrange3Inputs */

const id_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rentang tanggal tidak valid`)
};

const ms_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julat tarikh tidak sah`)
};

const da_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugyldig datointerval`)
};

const de_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger Datumsbereich`)
};

const en_us2_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid date range`)
};

const es_es2_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango de fechas inválido`)
};

const es_mx2_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango de fechas no válido`)
};

const fil_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi valid na date range`)
};

const fr_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plage de dates non valide`)
};

const it_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervallo date non valido`)
};

const hu_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Érvénytelen dátumintervallum`)
};

const nl_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldig datumbereik`)
};

const no_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugyldig datoområde`)
};

const pl_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieprawidłowy zakres dat`)
};

const pt_br2_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid date range`)
};

const pt_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo de datas inválido`)
};

const ro_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval de date invalid`)
};

const fi_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virheellinen päivämääräväli`)
};

const sv_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogiltigt datumintervall`)
};

const vi_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phạm vi ngày không hợp lệ`)
};

const tr_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçersiz tarih aralığı`)
};

const cs_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neplatný rozsah dat`)
};

const bg_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невалиден диапазон от дати`)
};

const ru_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неверный диапазон дат`)
};

const uk_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невірний діапазон дат`)
};

const ar_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاق تواريخ غير صالح`)
};

const hi_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अमान्य तारीख़ सीमा`)
};

const th_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงวันที่ไม่ถูกต้อง`)
};

const ja_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効な日付範囲`)
};

const zh_cn2_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无效的日期范围`)
};

const zh_hant1_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid date range`)
};

const ko_components_daterangepicker_invalidrange3 = /** @type {(inputs: Components_Daterangepicker_Invalidrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 날짜 범위입니다`)
};

/**
* | output |
* | --- |
* | "Invalid date range" |
*
* @param {Components_Daterangepicker_Invalidrange3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_daterangepicker_invalidrange3 = /** @type {((inputs?: Components_Daterangepicker_Invalidrange3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Daterangepicker_Invalidrange3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_daterangepicker_invalidrange3(inputs)
	if (locale === "ms") return ms_components_daterangepicker_invalidrange3(inputs)
	if (locale === "da") return da_components_daterangepicker_invalidrange3(inputs)
	if (locale === "de") return de_components_daterangepicker_invalidrange3(inputs)
	if (locale === "en-US") return en_us2_components_daterangepicker_invalidrange3(inputs)
	if (locale === "es-ES") return es_es2_components_daterangepicker_invalidrange3(inputs)
	if (locale === "es-MX") return es_mx2_components_daterangepicker_invalidrange3(inputs)
	if (locale === "fil") return fil_components_daterangepicker_invalidrange3(inputs)
	if (locale === "fr") return fr_components_daterangepicker_invalidrange3(inputs)
	if (locale === "it") return it_components_daterangepicker_invalidrange3(inputs)
	if (locale === "hu") return hu_components_daterangepicker_invalidrange3(inputs)
	if (locale === "nl") return nl_components_daterangepicker_invalidrange3(inputs)
	if (locale === "no") return no_components_daterangepicker_invalidrange3(inputs)
	if (locale === "pl") return pl_components_daterangepicker_invalidrange3(inputs)
	if (locale === "pt-BR") return pt_br2_components_daterangepicker_invalidrange3(inputs)
	if (locale === "pt") return pt_components_daterangepicker_invalidrange3(inputs)
	if (locale === "ro") return ro_components_daterangepicker_invalidrange3(inputs)
	if (locale === "fi") return fi_components_daterangepicker_invalidrange3(inputs)
	if (locale === "sv") return sv_components_daterangepicker_invalidrange3(inputs)
	if (locale === "vi") return vi_components_daterangepicker_invalidrange3(inputs)
	if (locale === "tr") return tr_components_daterangepicker_invalidrange3(inputs)
	if (locale === "cs") return cs_components_daterangepicker_invalidrange3(inputs)
	if (locale === "bg") return bg_components_daterangepicker_invalidrange3(inputs)
	if (locale === "ru") return ru_components_daterangepicker_invalidrange3(inputs)
	if (locale === "uk") return uk_components_daterangepicker_invalidrange3(inputs)
	if (locale === "ar") return ar_components_daterangepicker_invalidrange3(inputs)
	if (locale === "hi") return hi_components_daterangepicker_invalidrange3(inputs)
	if (locale === "th") return th_components_daterangepicker_invalidrange3(inputs)
	if (locale === "ja") return ja_components_daterangepicker_invalidrange3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_daterangepicker_invalidrange3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_daterangepicker_invalidrange3(inputs)
	return ko_components_daterangepicker_invalidrange3(inputs)
});
export { components_daterangepicker_invalidrange3 as "components.dateRangePicker.invalidRange" }